export enum TargetDeviceEnum {
  ADYEN = 'ADYEN',
  MYPOS = 'MYPOS',
  SUNMI= 'SUNMI',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}
